import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import IMG from '../data/images';
import { programmes, features } from '../data/siteData';


const Gallery = () => (
  <div>
    <section style={{ paddingTop:130,paddingBottom:70,background:'linear-gradient(135deg,var(--navy),var(--navy-dark))',textAlign:'center' }}>
      <h1 style={{ fontFamily:'var(--fh)',fontSize:'2.6rem',color:'#fff' }}><span style={{color:'var(--gold)'}}>Gallery</span></h1>
      <p style={{ color:'rgba(255,255,255,0.6)',maxWidth:500,margin:'12px auto 0',lineHeight:1.8 }}>A glimpse into the everyday magic at Finland Early Years.</p>
    </section>
    <section style={{padding:'90px 24px'}}>
      <div className='container'>
        <Reveal><div className='gold-bar'/><h2 className='sec-heading'>Life on Campus</h2><p className='sec-sub'>Explore, create, discover — every day is an adventure.</p></Reveal>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:14}} className='g3'>
          {[...IMG.gallery, IMG.kidsPlaying, IMG.classroom, IMG.playground].map((img,i) => (
            <Reveal key={i} delay={i*0.05} direction='scale'>
              <div style={{borderRadius:14,overflow:'hidden',height:i%3===0?300:220,cursor:'pointer'}}>
                <img src={img} alt='' style={{width:'100%',height:'100%',objectFit:'cover',transition:'transform 0.5s'}}
                  onMouseEnter={e=>e.target.style.transform='scale(1.08)'}
                  onMouseLeave={e=>e.target.style.transform='scale(1)'}/>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </div>
);
export default Gallery;


